<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">
                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="6" class="item">
                                <el-form-item label="图标" required prop="icon">
                                    <el-upload class="upload-demo"
                                        :action="uploadUrl"
                                        list-type="picture-card"
                                        :data='uploadData'
                                        :show-file-list="false"
                                        :on-success="handleImgSuccess"
                                        style="width:100%;margin-top:40px">
                                        <img v-if="editForm.icon" :src="editForm.icon" fit='cover' style="width: 100%;height: 100%;border-radius: 6px;">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                          <el-col :span="18" class="item">
                            <el-row>
                              <el-col :span="24" class="item">
                                <el-form-item label="分类" required prop="trainClassCode">
                                  <el-select v-model="editForm.trainClassCode" placeholder="请选择" style="width:100%">
                                    <el-option
                                        v-for="item in classList"
                                        :key="item.trainClassCode"
                                        :label="item.name"
                                        :value="item.trainClassCode">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            <el-row>
                              <el-col :span="24" class="item">
                                <el-form-item label="名称" required prop="title">
                                  <el-input v-model="editForm.title" placeholder="请输入名称"></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      <el-row>
                        <el-col :span="24" class="item">
                          <el-form-item label="描述" required prop="description">
                            <el-input v-model="editForm.description" type="textarea" :rows="5" placeholder="请输入描述"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>


                    </div>
                </el-form>
            </div>
            <div class="modal-footer">
              <el-button @click="closeSelf">取消</el-button>
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Edit',
        props:['attributeList'],
        data() {
            return {
                loading: false,

                uploadUrl:this.$shopUrl+'Upload/Imgs',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },

                editForm:{
                    timeStr:timeStr,
                    sign:'',
                  staffCode:getStaffCode(),

                  status:'',
                  title:'',
                  icon:'',
                  description:'',
                  trainClassCode:'',
                  trainCode:'',
                },

              classList:[],


                rules:{
                  title:[
                    { required: true, message: '请输入名称', trigger: 'blur' },
                  ],
                  description:[
                    { required: true, message: '请输入描述', trigger: 'blur' },
                  ],
                  trainClassCode:[
                    { required: true, message: '请选择分类', trigger: 'blur' },
                  ],
                  icon:[
                    { required: true, message: '请上传图片', trigger: 'blur' },
                  ],

                }

            }
        },
        methods: {
            init(row){
                this.editForm.trainClassCode = row.trainClassCode;
                this.editForm.title = row.title;
                this.editForm.description = row.description;
                this.editForm.status = row.status;
                this.editForm.icon = this.$imgUrl+row.icon;
                this.editForm.trainCode = row.trainCode,

                this.getClassList();
            },


          getClassList(){
            this.$axios({
              method: 'post',
              url: this.$shopUrl+'TrainClass/List',
              data: {
                timeStr:timeStr,
                sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                staffCode: getStaffCode(),
              }
            }).then( (response)=> {
              //console.log(response);
              if(response.data.error == 0){
                this.classList = response.data.data.list;

              }else if(response.data.error == 1){
                this.$message(response.data.message);
              }else{
                console.log(response.data.message);
              }

            }).catch(function (error) {
              console.log(error);
            });
          },


          closeSelf() {
                this.$emit("closeEdit");
            },

            handleImgSuccess(res) {
                this.editForm.icon = this.$imgUrl+res.data.path;
            },

            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        if(!this.editForm.icon){
                            this.$message({type: 'warning', message: '请上传图标'});
                            return;
                        }
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })
            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.editForm.icon=this.editForm.icon.replace(this.$imgUrl,'')

              this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Train/Edit",
                    data: this.editForm
                }).then((response) => {
                        this.loading = false;

                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    })
            },



        }
    }


</script>

<style lang="scss" scoped>

</style>
